module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGklEQVQokWMYBTQAjP////8/GrBDGzAwMAAAFDkD/rHDP2sAAAAASUVORK5CYII="